import { memo } from 'react'

import { Id, RowType } from '../types'

type Props<TCol extends { id: Id }> = RowType<TCol> & {
    cols: TCol[]
    gridTemplateColumns: string
}

const HeaderRowComponent = <TCol extends { id: Id }>({ cols, gridTemplateColumns, rowHeader, cellClassName, cellRender }: Props<TCol>) => (
    <tr className="grid border-t first:border-t-0" style={{ gridTemplateColumns }}>
        {rowHeader && <td className="sticky left-0 z-elevated overflow-hidden truncate bg-surface-base">{rowHeader()}</td>}

        {cols.map(col => (
            <td key={col.id} className={`overflow-hidden ${cellClassName?.(col)}`}>
                {cellRender?.(col)}
            </td>
        ))}
    </tr>
)

export const HeaderRow = memo(HeaderRowComponent) as typeof HeaderRowComponent
